const Dropdown = (props: any) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            style={{ minWidth: '36px', minHeight: '36px' }}
            viewBox="0 0 36 36"
            fill="none"
            {...props}
        >
            <path
                d="M24.5999 15.4609L19.1666 20.8943C18.5249 21.5359 17.4749 21.5359 16.8332 20.8943L11.3999 15.4609"
                stroke="#747474"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Dropdown;
